import SubregionWindow from "./SubregionWindow";
import SubregionOutlineLayer from "./SubregionOutlineLayer";
import ExpansionTextItem from "./ExpansionTextItem";
import Scalebar from "./Scalebar";

export default function PositionedItem({
  type, style, position, nodeId, node, nodes, regions,
  selected, onEvent, onItemClick,
  thumbnail,
  label,
  evaluate,
  parentBox,


}){

  if( type === "regionOutline" ){
    return null;
  }

  switch( type ){
    case "scalebar":{

      let props = {
        selected,
        ref:el => {
          if( el ){
            ;
          }else{
            ;
          }
        },

        onEvent:(onEvent||onItemClick),
        evaluate,
        parentBox,
        style,
        position,
        nodeId,
        node,
        nodes,
        regions,
      }
      return (
        <Scalebar {...props}/>
      )
    }
    case "text":{


      let textStyle = {...style};
      if( thumbnail ){
        textStyle.fontSize = 10;
      }

      let borderProps = ["borderTop","borderBottom","borderLeft","borderRight"];

      let borderStyles = {};



      borderProps.forEach(prop => {
        let borderStyleInfo = textStyle[prop];

        let { borderThickness=1, borderColor="black" } = textStyle || {};
        if( borderStyleInfo ){
          borderStyles[prop] = 
            `${borderThickness}px solid ${borderColor}`;
        }
      })

      let props = {
        selected,
        nodeId,
        node,
        textStyle:{
          ...textStyle,
          ...borderStyles
        },
        label:(label||"Label"),//:"100",

        onEvent:(onEvent||onItemClick),
      }

      return <ExpansionTextItem {...props}/>
    }
    case "region":{

      let props = {
          selected,
          onItemClick,
          evaluate,
          nodeId,
          node,
          nodes,
          regions,
          parentBox,
          thumbnail,
          style,
        }
      return <SubregionWindow {...props}/>
    }
    case "regionOutline":{
      return null;
    }

    /*case "regionOutline":{

      let props = {
          selected,
          nodeId,
          node,
          regions,
          onItemClick,
          position:{},
          onEvent:(onEvent||onItemClick),
        }

      return <SubregionOutlineLayer {...props}/>
    }*/
    default:
      throw Error(`No registered node type '${type}'.`);

  }


}
